import React from 'react';
import { motion } from 'framer-motion';
import { 
  Storefront, 
  Package, 
  Cpu, 
  CloudArrowUp, 
  QrCode, 
  Database,
  ChartLineUp,
  Globe
} from "@phosphor-icons/react";

interface TechAmbientIconsProps {
  section: 'pdv' | 'erp' | 'final' | 'stats';
}

const TechAmbientIcons: React.FC<TechAmbientIconsProps> = ({ section }) => {
  const iconSets = {
    pdv: [
      { Icon: Storefront, size: 48, top: '10%', left: '5%', delay: 0, opacity: 0.15, blur: 'blur-[1px]' },
      { Icon: QrCode, size: 56, top: '70%', left: '15%', delay: 1, opacity: 0.1, blur: 'blur-[2px]' },
      { Icon: Globe, size: 40, top: '30%', right: '10%', delay: 2, opacity: 0.1, blur: 'blur-[1px]' },
    ],
    erp: [
      { Icon: Package, size: 52, top: '15%', left: '8%', delay: 0.5, opacity: 0.12, blur: 'blur-[1px]' },
      { Icon: Database, size: 64, bottom: '20%', left: '12%', delay: 1.5, opacity: 0.08, blur: 'blur-[3px]' },
      { Icon: Cpu, size: 44, top: '25%', right: '15%', delay: 0.8, opacity: 0.15, blur: 'blur-[2px]' },
    ],
    final: [
      { Icon: ChartLineUp, size: 60, top: '20%', left: '10%', delay: 0.2, opacity: 0.1, blur: 'blur-[2px]' },
      { Icon: CloudArrowUp, size: 48, bottom: '30%', right: '12%', delay: 1.2, opacity: 0.15, blur: 'blur-[1px]' },
    ],
    stats: [
      { Icon: Cpu, size: 40, top: '40%', left: '5%', delay: 2.2, opacity: 0.05, blur: 'blur-[4px]' },
    ]
  };

  const currentSet = iconSets[section] || [];

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0 select-none">
      {currentSet.map((item, idx) => (
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 20 }}
          animate={{ 
            opacity: item.opacity, 
            y: [0, -20, 0],
          }}
          transition={{ 
            opacity: { duration: 1, delay: item.delay },
            y: { duration: 6, repeat: Infinity, ease: "easeInOut", delay: item.delay }
          }}
          className={`absolute ${item.blur}`}
          style={{ 
            top: item.top, 
            left: item.left, 
            right: item.right, 
            bottom: item.bottom,
            color: 'white'
          }}
        >
          <item.Icon size={item.size} weight="thin" />
        </motion.div>
      ))}
    </div>
  );
};

export default TechAmbientIcons;
